import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

export const useDisableIntegratedSolutionFlow = (): boolean => {
	// keep this hook here to update when translations obtained
	const t = useTranslation();
	const disableIntegratedSolutionFlow = t('integratedSolutionFlow.disable');

	return disableIntegratedSolutionFlow !== undefined && disableIntegratedSolutionFlow.toLowerCase() === 'true'
		? true
		: false;
};
